import { render } from "./AboutUs.vue?vue&type=template&id=556d5270&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=556d5270&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556d5270"]])

export default __exports__